var _g, _rect, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_128_8348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 55,
    height: 55,
    rx: 18,
    fill: "#262C64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_128_8348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 15,
    width: 55,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 55,
    height: 55,
    rx: 18,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_128_8348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7558 47.491C52.6276 47.4895 48.4623 43.2879 48.4639 38.1174C48.4639 32.9469 52.6307 28.7484 57.7604 28.75C62.8902 28.7516 67.0539 32.9515 67.0539 38.1236C67.0523 43.2926 62.8855 47.4926 57.7558 47.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5496 49.3846C54.0837 50.795 53.6287 52.1757 53.1705 53.5548C52.2791 56.2489 51.4 58.9461 50.4884 61.6323C50.1685 62.5747 50.3657 63.3245 51.0599 64.0196C53.0105 65.9701 54.9379 67.9425 56.8823 69.9149C56.7798 70.0589 56.6121 69.9759 56.4738 69.9775C51.4016 69.9822 46.3309 69.9838 41.2586 69.9806C39.9199 69.9806 39.1527 69.2277 39.1713 67.8877C39.1993 65.8417 39.0626 63.7957 39.3903 61.7544C40.3609 55.7245 45.4565 50.5634 51.4342 49.5991C52.4452 49.4363 53.4609 49.322 54.5496 49.3846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9874 49.3914C67.9932 49.0251 74.5269 54.1831 76.0085 61.1664C76.5086 63.5254 76.3378 65.908 76.3269 68.2843C76.3222 69.2752 75.4463 69.978 74.3887 69.9812C71.368 69.9874 68.3473 69.9843 65.3266 69.9843C63.2937 69.9843 61.2608 69.9843 59.2278 69.9843C59.0399 69.9843 58.8535 69.9843 58.5352 69.9843C59.0399 69.4756 59.4577 69.056 59.8739 68.6365C61.3943 67.104 62.9039 65.562 64.4383 64.0452C65.1511 63.3407 65.3437 62.5784 65.0176 61.6078C63.6897 57.6646 62.3976 53.7104 61.093 49.7593C61.0558 49.6497 61.0294 49.5385 60.9874 49.3914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8165 51.7158C58.1908 52.8507 58.5635 53.9857 58.9409 55.119C59.6522 57.2574 60.3635 59.3941 61.081 61.5309C61.1711 61.8002 61.2146 62.0052 60.963 62.2494C59.9737 63.209 59.0046 64.1905 58.0479 65.1846C57.8087 65.4335 57.6829 65.4022 57.4609 65.172C56.5011 64.1811 55.5289 63.2028 54.5473 62.2353C54.3532 62.0444 54.3144 61.8784 54.3998 61.6264C55.504 58.3312 56.5989 55.0329 57.6969 51.7346C57.7357 51.7283 57.7761 51.7221 57.8165 51.7158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_128_8348",
    x: 0,
    y: 0,
    width: 115,
    height: 115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.172549 0 0 0 0 0.392157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_128_8348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_128_8348",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.ebe79587fb5edf5de41dc51f3aaa052f.svg";
export { ForwardRef as ReactComponent };